import Image from "./../image";
import { useTranslation } from "react-i18next";
interface ItemSelectorProps {
  isOpen: boolean;
  onSelect: (value: string) => void;
  selectionList: string[];
  currentValue: string;
}

const ItemSelector: React.FC<ItemSelectorProps> = ({
  isOpen,
  onSelect,
  selectionList,
  currentValue,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleSelect = (value: string) => {
    onSelect(value);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-paper-gray rounded-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center mb-4 px-[20px] pt-[20px]">
          <h2 className="text-xl font-semibold primary-text-color">
            {t("floor")}
          </h2>
        </div>

        <div className="flex-1 overflow-y-auto">
          {selectionList.map((option, index) => (
            <button
              key={option}
              onClick={() => handleSelect(option)}
              className={`px-[20px] w-full text-left p-3 rounded flex items-center justify-between ${
                currentValue === option ? "bg-green-light" : ""
              }`}
            >
              <div className="font-medium primary-text-color">{option}</div>
              {currentValue === option ? (
                <Image
                  aria-hidden
                  src="/assets/icon_check.png"
                  alt="selected"
                  width={20}
                  height={20}
                />
              ) : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ItemSelector;
